var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 12.3333V13.6216C4.33325 13.8057 4.18401 13.9549 3.99992 13.9549C3.92194 13.9549 3.84643 13.9276 3.78653 13.8777L1.04054 11.5894C0.899112 11.4715 0.880005 11.2613 0.997859 11.1199C1.06119 11.0439 1.15501 11 1.25394 11H10.9999C11.7363 11 12.3333 10.403 12.3333 9.66665V4.3333H13.6666V9.66665C13.6666 11.1394 12.4727 12.3333 10.9999 12.3333H4.33325ZM9.66658 1.66663V0.378316C9.66658 0.194223 9.81585 0.0449829 9.99992 0.0449829C10.0779 0.0449829 10.1534 0.0723229 10.2133 0.122243L12.9593 2.41056C13.1007 2.52842 13.1199 2.73861 13.002 2.88004C12.9387 2.95603 12.8449 2.99997 12.7459 2.99997L2.99992 2.99996C2.26354 2.99996 1.66659 3.59692 1.66659 4.3333V9.66665H0.333252V4.3333C0.333252 2.86054 1.52716 1.66663 2.99992 1.66663H9.66658Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d419f70f.svg";
export { ForwardRef as ReactComponent };